import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';


if ($('.slider-type-2').length) {
	$('.slider-type-2').each(function() {
		var $this = $(this);
		var section = $(this).closest('section');
		var pagination = section.find('.slider-pagination');

		function getSlideDelay($slide) {
			var interval = parseFloat($slide.attr('data-interval'));
			if (isNaN(interval) || interval <= 0) {
				return 4500;
			}
			return interval * 1000;
		}

		function applyAutoplayDelay(swiper, delay) {
			if (!swiper.params.autoplay) return;

			swiper.params.autoplay.delay = delay;

			if (swiper.autoplay) {
				var wasRunning = swiper.autoplay.running;
				if (wasRunning) {
					swiper.autoplay.stop();
				}
				swiper.autoplay.start();
			}
		}

		var initialDelay = getSlideDelay($this.find('.swiper-slide').first());

		var swiperInstance = new Swiper($(this)[0], {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoHeight: false,
			autoplay: {
				delay: initialDelay,
				disableOnInteraction: false,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			loop: false,
			navigation: false,
			allowTouchMove: true,
			on: {
				init: function (swiper) {
					
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')

					let maxHeight = 0;
					section.find('[data-slide-content] .block-content').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeight) {
							maxHeight = contentHeight;
						}
					});
					section.find('[data-slide-content] .block-content').css('height', maxHeight);

					let maxHeightRow = 0;
					section.find('[data-slide-content] .row').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeightRow) {
							maxHeightRow = contentHeight;
						}
					});
					// section.find('[data-slide-content] .row').css('height', maxHeightRow);

					applyAutoplayDelay(swiper, getSlideDelay($this.find('.swiper-slide-active')));
				},
				slideChangeTransitionStart: function (swiper) {
					
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')
				},
				slideChangeTransitionEnd: function (swiper) {
					var $activeSlide = $this.find('.swiper-slide-active');
					var newDelay = getSlideDelay($activeSlide);

					applyAutoplayDelay(swiper, newDelay);
				}
			},
		});
		
		// Store instance globally for backward compatibility
		window.sliderType2 = swiperInstance;
		
		// Custom Cursor Arrow functionality (only if more than 1 slide)
		if (swiperInstance.slides.length > 1) {
			initCustomCursor($this, section, swiperInstance);
		} else {
			// For single slides, restore normal cursor
			$this.css('cursor', 'auto');
		}
	})
}

if ($('.slider-type-1').length) {
	$('.slider-type-1').each(function() {
		var $this = $(this);
		var section = $this.closest('section')
		var pagination = section.find('.swiper-pagination');

		var swiperInstance = new Swiper($(this)[0], {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 24,
			speed: 800,
			autoHeight: false,
			autoplay: {
				delay: 4500,
				disableOnInteraction: false,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			loop: true, 
			navigation: {
				nextEl: section.find('.swiper-button-next')[0],
				prevEl: section.find('.swiper-button-prev')[0],
			},
			allowTouchMove: true,
			// Animation handled via CSS transitions on swiper classes
		});

		window.sliderType1 = swiperInstance;
	})
}

// Custom Cursor Arrow functionality
function initCustomCursor($slider, $section, swiperInstance) {
	const $cursorArrow = $section.find('.cursor-arrow');
	let isHovering = false;
	let currentMouseX = 0;
	let currentMouseY = 0;
	
	// Mouse move handler
	function handleMouseMove(e) {
		if (!isHovering) return;
		
		currentMouseX = e.clientX;
		currentMouseY = e.clientY;
		
		// Update cursor position smoothly
		gsap.to($cursorArrow[0], {
			x: currentMouseX,
			y: currentMouseY,
			duration: 0.2,
			ease: "power2.out"
		});
		
		// Get slider bounds
		const sliderRect = $slider[0].getBoundingClientRect();
		const sliderCenterX = sliderRect.left + (sliderRect.width / 2);
		
		// Determine if mouse is on left or right half
		if (currentMouseX < sliderCenterX) {
			$cursorArrow.removeClass('right').addClass('left');
		} else {
			$cursorArrow.removeClass('left').addClass('right');
		}
	}
	
	// Mouse enter handler
	$slider.on('mouseenter', function(e) {
		isHovering = true;
		$cursorArrow.addClass('active');
		
		// Set initial position
		currentMouseX = e.clientX;
		currentMouseY = e.clientY;
		
		// Set initial position without animation
		gsap.set($cursorArrow[0], {
			x: currentMouseX,
			y: currentMouseY
		});
		
		// Determine initial rotation
		const sliderRect = $slider[0].getBoundingClientRect();
		const sliderCenterX = sliderRect.left + (sliderRect.width / 2);
		
		if (currentMouseX < sliderCenterX) {
			$cursorArrow.removeClass('right').addClass('left');
		} else {
			$cursorArrow.removeClass('left').addClass('right');
		}
	});
	
	// Mouse leave handler
	$slider.on('mouseleave', function() {
		isHovering = false;
		$cursorArrow.removeClass('active left right');
	});
	
	// Mouse move handler
	$slider.on('mousemove', handleMouseMove);
	
	// Click handler for navigation
	$slider.on('click', function(e) {
		if (!isHovering) return;
		
		e.preventDefault();
		
		const sliderRect = $slider[0].getBoundingClientRect();
		const sliderCenterX = sliderRect.left + (sliderRect.width / 2);
		const clickX = e.clientX;
		
		
		if (clickX < sliderCenterX) {
			// Click on left half - go to previous slide
			if (swiperInstance) {
				const currentIndex = swiperInstance.realIndex || swiperInstance.activeIndex;
				const totalSlides = swiperInstance.slides.length;
				
				// Manual loop logic
				if (currentIndex <= 0) {
					// At first slide, go to last slide (loop)
					swiperInstance.slideTo(totalSlides - 1);
				} else {
					// Go to previous slide
					swiperInstance.slidePrev();
				}
			}
		} else {
			// Click on right half - go to next slide
			if (swiperInstance) {
				const currentIndex = swiperInstance.realIndex || swiperInstance.activeIndex;
				const totalSlides = swiperInstance.slides.length;
				
				// Manual loop logic
				if (currentIndex >= totalSlides - 1) {
					// At last slide, go to first slide (loop)
					swiperInstance.slideTo(0);
				} else {
					// Go to next slide
					swiperInstance.slideNext();
				}
			}
		}
	});
	
	// Hide cursor arrow when slider is not active or on mobile
	function checkVisibility() {
		if ($(window).width() < 1024 || !swiperInstance || swiperInstance.slides.length <= 1) {
			$cursorArrow.removeClass('active left right');
			isHovering = false;
			$slider.css('cursor', 'auto'); // Restore normal cursor
		} else {
			$slider.css('cursor', 'none'); // Hide cursor for custom arrow
		}
	}
	
	// Check on resize
	$(window).on('resize', checkVisibility);
	
	// Initial check
	checkVisibility();
	
	// Check if cursor is already over the slider on page load
	// This handles the case where sliderType2 is the first section
	$(document).ready(function() {
		// Wait a bit for page to settle, then check mouse position
		setTimeout(function() {
			// Get current mouse position (if available)
			$(document).one('mousemove', function(e) {
				const sliderRect = $slider[0].getBoundingClientRect();
				const mouseX = e.clientX;
				const mouseY = e.clientY;
				
				// Check if mouse is within slider bounds
				if (mouseX >= sliderRect.left && 
					mouseX <= sliderRect.right && 
					mouseY >= sliderRect.top && 
					mouseY <= sliderRect.bottom) {
					
					// Trigger mouseenter manually
					isHovering = true;
					$cursorArrow.addClass('active');
					
					currentMouseX = mouseX;
					currentMouseY = mouseY;
					
					// Set initial position
					gsap.set($cursorArrow[0], {
						x: currentMouseX,
						y: currentMouseY
					});
					
					// Determine initial rotation
					const sliderCenterX = sliderRect.left + (sliderRect.width / 2);
					if (currentMouseX < sliderCenterX) {
						$cursorArrow.removeClass('right').addClass('left');
					} else {
						$cursorArrow.removeClass('left').addClass('right');
					}
				}
			});
		}, 100);
	});
}




if ($('.slider-rental-gallery').length) {
	var galleryThumb = new Swiper(".slider-rental-gallery-thumb", {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			640: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 5,
			},
			1024: {
				slidesPerView: 7,
			},
			1280: {
				slidesPerView: 9,
			},
			1696: {
				slidesPerView: 10,
			},
		},
	});
	var galleryBig = new Swiper(".slider-rental-gallery", {
		spaceBetween: 10,
		navigation: {
			nextEl: $('[data-gallery]').find('.swiper-button-next')[0],
			prevEl: $('[data-gallery]').find('.swiper-button-prev')[0],
		},
		thumbs: {
			swiper: galleryThumb,
		},
		hashNavigation: {
			watchState: true,
		},
		watchSlidesProgress: true,
		on: {
			init: function () {
				// console.log('swiper initialized');
			},
			slideChangeTransitionStart: function (swiper) {
				console.log()
				$('[data-gallery] .slider-progress .current').text(swiper.realIndex + 1);
			},
		},
	});
}


function initType3Slider() {
	$('.slider-type-3').each(function(index) {
		var slider = $(this);
		var offsetEl = slider.closest('section').find('.column-left > *');
		var offset = offsetEl.offset().left;
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.1,
			centeredSlides: false,
			spaceBetween: 14,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: false,
			scrollbar: false,
			navigation: false,
			slidesOffsetBefore: offset,
			slidesOffsetAfter: offset,
			navigation: {
				nextEl: slider.find('.swiper-button-next')[0],
				prevEl: slider.find('.swiper-button-prev')[0],
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.8,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1280: {
					slidesPerView: 2.5
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	});
}

if ($('.slider-type-3').length) {
	let lastWindowWidth = window.innerWidth;

	initType3Slider();

	let resizeTimeout;
	$(window).on('resize', function () {
		// Only act on horizontal resize
		if (window.innerWidth !== lastWindowWidth) {
			lastWindowWidth = window.innerWidth;

			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function () {
				initType3Slider();
			}, 300);
		}
	});
}

if ($('[data-section="galleryImages"]').length) {
	$('[data-section="galleryImages"]').each(function(index) {
		var slider = $(this).find('.slider-type-gallery');
		var prevArr = $(this).find('.swiper-button-prev')[0];
		var nextArr = $(this).find('.swiper-button-next')[0];
		var pagination = slider.closest('section').find('.slider-pagination');

		// Destroy existing instance if it exists
		if (slider[0].swiper) {
			slider[0].swiper.destroy(true, true);
		}

		//ensure more than 5
		var $slides = slider.find('.swiper-slide');
		if ($slides.length < 6) {
			const needed = 6 - $slides.length;
			for (var i = 0; i < needed; i++) {
				const $slideToClone = $slides.eq(i % $slides.length);
				const $clone = $slideToClone.clone(true);
				slider.find('.swiper-wrapper').append($clone);
			}
		} 

		// Reinitialize with updated offset
		new Swiper(slider[0], {
			slidesPerView: 1.25,
			centeredSlides: true,
			spaceBetween: 16,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: true,
			scrollbar: false,
			navigation: {
				nextEl: nextArr,
				prevEl: prevArr,
			},
			pagination: {
				el: pagination[0],
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 1.75,
					spaceBetween: 32
				},
			},
		});
	});
}